import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { DayforceWebhooksMain } from './components/DayforceWebhooksMain'
import { DayforceWebhooksProvider } from './context/DayforceWebhooksProvider'
import { DayforceAgenciesProvider } from '../shared/context/DayforceAgenciesProvider'

export const DayforceWebhooks = () => {
  return (
    <NuqsAdapter>
      <DayforceAgenciesProvider>
        <DayforceWebhooksProvider>
          <DayforceWebhooksMain />
        </DayforceWebhooksProvider>
      </DayforceAgenciesProvider>
    </NuqsAdapter>
  )
}
